import { render, staticRenderFns } from "./table-products.vue?vue&type=template&id=7ac05c22&"
import script from "./table-products.vue?vue&type=script&lang=js&"
export * from "./table-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports